package com.example.mystybag.appCore.model.pages

import com.example.mystybag.core.model.CountryItem
import com.example.mystybag.sharedmodels.project.responseModels.merchant.MerchantLocationResponseModel

data class EditEmployeeUIState(
    val staffId: Long = 0L,
    val email: String = "",
    val emailErrorMsg: String = "",
    val emailIsError: Boolean = false,
    val firstName: String = "",
    val firstNameErrorMsg: String = "",
    val firstNameIsError: Boolean = false,
    val lastName: String = "",
    val lastNameErrorMsg: String = "",
    val lastNameIsError: Boolean = false,
    val phoneNumber: String = "",
    val phoneNumberErrorMsg: String = "",
    val phoneNumberIsError: Boolean = false,
    val dialCode: String = "",
    val dialCodeErrorMsg: String = "",
    val dialCodeIsError: Boolean = false,
    val countries: List<CountryItem> = emptyList(),
    val showDialCodePicker: Boolean = false,
    val role: String = "STAFF",
    val locations: List<MerchantLocationResponseModel> = emptyList(),
    val selectedLocationIds: Set<Long> = emptySet(),
    val locationsErrorMsg: String = "",
    val locationsIsError: Boolean = false,
    /** Permission toggle: staff is allowed to create new bags. Locations are owner-only and never granted to staff. */
    val canCreateBags: Boolean = false,
    /** Permission toggle: staff can see the revenue value on the dashboard (otherwise masked as "**.**"). */
    val canViewRevenue: Boolean = false,
    val isLoading: Boolean = false,
    val isInitialLoad: Boolean = true
)
